module.exports = __webpack_public_path__ + "0890b8536f976d0288ace76db6cfae06.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/wall_items/window-sunny-beach.png
// module id = 1614
// module chunks = 0